import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import {useParams} from "react-router-dom";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";

const Content = () => {
    const {slug} = useParams();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [content, setContent] = React.useState('');
    React.useEffect(() => {

        API.getContent(slug)
            .then((response) => {
                setIsLoaded(true);
                setContent(response.data)
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

    }, [slug]);
    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Header title={content.title} hasBack={true}/>
            <section className="container-fluid  mt-3 py-3 rtl px-0 mx-0 services-list ">
                <div className="row mx-0 px-0">
                    <div className="col-12 px-0 text-center">
                        <img src={content.image} alt={content.title} className='w-100'/>
                    </div>
                    <div className="col-12 text-center fw-bold mt-3 text-big-1 border-bottom pb-3">
                        {content.title}
                    </div>
                    <div className="col-12 text-justify p-4">
                        <p  dangerouslySetInnerHTML={{ __html: content.content }}></p>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
};

export default Content;